import React, { Component } from "react";
import moment from "moment";
import { Drawer, Table, Tag, Icon } from "antd";
import { connect } from "react-redux";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';


class GeneratedInvoiceDetails extends Component {
    state = {
        visible: true,
        arr: [],
        loading: false
    };


    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 400);
    };



    render() {
        const { title, count, bgColorClass, icon, arr } = this.props.param;
        const { loading } = this.state;

        const column = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                width: 60,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Invoice Number',
                key: 'invoiceNumber',
                dataIndex: 'invoiceNumber',
                render: (text) => <strong>{text}</strong>
            },
            {
                title: 'Invoice Amount',
                key: 'commissionGrandTotal',
                // Adding sorter for numerical values
                sorter: (a, b) => a.commissionGrandTotal - b.commissionGrandTotal,
                render: (text, record) => {
                    // Safe access for React 16.7
                    var currency = record && record.invoices && record.invoices[0] ? record.invoices[0].currency : '';
                    var amount = record && record.commissionGrandTotal ? record.commissionGrandTotal : 0;
                    return (
                        <div style={{ fontWeight: 'bold', color: '#10b981' }}>
                            {amount} ({currency})
                        </div>
                    )
                }
            },
            {
                title: 'Generated By',
                key: 'createdByUser',
                render: (text, record) => {
                    // Safe access to the nested creator name
                    var creator = record && record.createdByUser ? record.createdByUser.name : 'N/A';
                    var time = record && record.createdByUser && record.createdByUser.time ? record.createdByUser.time : null;

                    return (
                        <div>
                            <div style={{ fontWeight: 600, color: '#595959' }}>{creator}</div>
                            {time && (
                                <div style={{ fontSize: '11px', color: '#bfbfbf' }}>
                                    {moment(time).format(dateFormat + ' HH:mm A')}
                                </div>
                            )}
                        </div>
                    );
                }
            }
        ];

        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '98%' }}>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                            {/* Render the dynamic icon here. If it's a React component, it will render. */}
                            <span style={{ marginRight: 12, display: 'flex', fontSize: '20px' }}>
                                {icon ? icon : <Icon type="profile" />}
                            </span>
                            {title}
                        </span>
                        <Tag className="count-tag">{count} TOTAL</Tag>
                    </div>
                }
                placement="right"
                onClose={this.onClose}
                visible={this.state.visible}
                width={500}
                className={`dynamic-drawer ${bgColorClass}`}
            >
                <Table
                    columns={column}
                    ref={this.table}
                    loading={loading}
                    dataSource={arr}
                    rowKey={(record, index) => index}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50"],
                    }}
                />
            </Drawer>
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    currentUser: global.currentUser,
});

export default connect(mapStateToProps, null)(GeneratedInvoiceDetails);